import {FullscreenControl, Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
import "./YandexLocationMap.scss";

const parseCoordinate = value => {
    const parsedValue = parseFloat(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
};

const YandexLocationMap = ({lat, long, zoom = 16, className = ""}) => {
    const latitude = parseCoordinate(lat);
    const longitude = parseCoordinate(long);
    const hasCoordinates = latitude !== null && longitude !== null;
    const mapClassName = ["yandex-location-map", className].filter(Boolean).join(" ");

    if (!hasCoordinates) {
        return (
            <div className={`${mapClassName} yandex-location-map--empty`}>
                Location coordinates are not available.
            </div>
        );
    }

    const coordinates = [latitude, longitude];

    return (
        <YMaps>
            <div className={mapClassName}>
                <Map
                    defaultState={{center: coordinates, zoom}}
                    style={{width: "100%", height: "100%"}}
                >
                    <FullscreenControl/>
                    <Placemark
                        defaultGeometry={coordinates}
                    />
                </Map>
            </div>
        </YMaps>
    );
};

export default YandexLocationMap;
